/* eslint-disable no-restricted-globals, no-restricted-properties */

const customSessionStorage = {
  clear: (): void => {
    try {
      window.sessionStorage.clear();
    } catch (error) {
      console.error(
        'CustomSessionStorage: Error to clear the sessionStorage',
        error,
      );
    }
  },
  getItem: (key: string): string | null => {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      console.error(
        `CustomSessionStorage: Error to get the value for the key ${key}`,
        error,
      );
      return null;
    }
  },
  removeItem: (key: string): void => {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      console.error(
        `CustomSessionStorage: Error to remove the value for the key ${key}`,
        error,
      );
    }
  },
  setItem: (key: string, value: string): void => {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      console.error(
        `CustomSessionStorage: Error to set the value for the key ${key}`,
        error,
      );
    }
  },
};

export default customSessionStorage;
